import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { Fragment, useCallback, useState } from 'react';
import { ReactComponent as PulsePlusIcon } from '../../assets/pulse-plus-icon.svg';
import ImportURLField from './ImportURLField';

export default function ImportURLList({ urls, onChange, decorators, errorMessage, enableAddButton = true }) {
  const [selectedUrlIndex, setSelectedUrlIndex] = useState(0);

  const handleURLChanged = useCallback(
    (newUrl, replaceIndex) =>
      onChange(
        urls.map((urlObj, index) => (replaceIndex === index ? { url: newUrl, hasError: false } : urlObj))
      ),
    [onChange, urls]
  );

  const handleAddURL = useCallback(() => {
    onChange([...urls].concat([{ url: '', hasError: false }]));
    setSelectedUrlIndex(urls.length);
  }, [onChange, urls]);

  const handleDeleteURL = useCallback(
    (index) => {
      onChange(urls.slice(0, index).concat(urls.slice(index + 1)));
      setSelectedUrlIndex(urls.length - 2);
    },
    [onChange, urls]
  );

  const handleSelectedURL = useCallback((index) => {
    setSelectedUrlIndex(index);
  }, []);

  return (
    <Box>
      <Grid container alignItems="center" rowGap={1}>
        {urls.map((urlObj, index) => {
          return (
            <Fragment key={index}>
              <Grid item xs={12} md={2} sx={{ textAlign: { md: 'right' }, pr: 4 }}>
                {urls.length > 1 && (
                  <Typography color="primary" variant="body2">
                    Page {index + 1}
                  </Typography>
                )}
              </Grid>
              <Grid item xs md={8}>
                <ImportURLField
                  initialURL={urlObj?.url}
                  isFocused={index === selectedUrlIndex}
                  onStateChange={(importURL) => handleURLChanged(importURL, index)}
                  onRemove={urls.length > 1 ? () => handleDeleteURL(index) : null}
                  onFocus={() => handleSelectedURL(index)}
                  showErrors={false} // disable per-line errors because they throw off the formatting
                  notifyErrorStates={true} // this makes it so that onStateChange emits all state changes, even invalid urls
                />
              </Grid>
              <Grid
                item
                xs={1}
                md={2}
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  pl: { xs: 1, sm: 2 },
                }}>
                {decorators?.[index] ? decorators[index] : <></>}
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
      <Box mt={1}>
        <Grid container>
          <Grid item xs={12} md={2}></Grid>
          <Grid item xs md={8}>
            <Tooltip title={enableAddButton ? '' : 'Reached max number of URLs'} placement="right">
              <Box
                onClick={enableAddButton ? () => handleAddURL() : () => {}}
                sx={{
                  display: 'inline-flex',
                  cursor: 'pointer',
                  opacity: enableAddButton ? 1.0 : 0.7,
                }}>
                <PulsePlusIcon style={{ height: '16px', width: '16px' }} />
                <Typography color="primary" fontSize={12} ml={1}>
                  Add
                </Typography>
              </Box>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
      <Box mt={1}>
        <Grid container>
          <Grid item xs={12} md={2} />
          <Grid item xs md={8}>
            <Typography color="error" fontSize={12}>
              {urls?.length && errorMessage}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
